import { Country } from 'shared/types/types'

const regexpMap = {
  [Country.RU]: /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/,
  [Country.KZ]: /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/,
  [Country.BY]: /^(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})$/,
  [Country.UZ]: /^(\d{3})(\d{2})(\d{3})(\d{4})$/,
  [Country.GE]: /^(\d{3})(\d{2})(\d{3})(\d{4})$/,
  [Country.TJ]: /^(\d{3})(\d{2})(\d{3})(\d{4})$/,
  [Country.AM]: /^(\d{3})(\d{2})(\d{2})(\d{4})$/,
  [Country.KG]: /^(\d{3})(\d{3})(\d{6})$/,
  [Country.TM]: /^(\d{3})(\d{2})(\d{2})(\d{2})(\d{2})$/,
}

export function phonePipe(str: number | string, country: Country = Country.RU, maskPhone = false) {
  const match = str.toString().match(regexpMap[country])

  if (!match) {
    return `+${str}`
  }

  const pipe = maskPhone ? (value: string) => value?.replace(/[\d+]/g, '*') : (value: string) => value

  const masksMap = {
    [Country.RU]: `+${match[1]} (${pipe(match[2])}) ${pipe(match[3])}-${match[4]}-${match[5]}`,
    [Country.KZ]: `+${match[1]} (${pipe(match[2])}) ${pipe(match[3])}-${match[4]}-${match[5]}`,
    [Country.BY]: `+${match[1]} (${pipe(match[2])}) ${pipe(match[3])}-${match[4]}-${match[5]}`,
    [Country.UZ]: `+${match[1]} ${pipe(match[2])} ${pipe(match[3])} ${match[4]}`,
    [Country.GE]: `+${match[1]} ${pipe(match[2])} ${pipe(match[3])} ${match[4]}`,
    [Country.TJ]: `+${match[1]} ${pipe(match[2])} ${pipe(match[3])} ${match[4]}`,
    [Country.AM]: `+${match[1]} ${pipe(match[2])} ${pipe(match[3])} ${match[4]}`,
    [Country.KG]: `+${match[1]} ${pipe(match[2])} ${match[3]}`,
    [Country.TM]: `+${match[1]} (${pipe(match[2])})${pipe(match[3])} ${match[4]} ${pipe(match[5])}`,
  }

  return masksMap[country]
}

export function snilsPipe(str: number | string) {
  const match = str.toString().match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/)

  if (!match) {
    return `${str}`
  }

  return `${match[1]}-${match[2]}-${match[3]} ${match[4]}`
}
